import { ColorEnum } from '@/constants/color'
import { PrintJobType } from '@/features/print/constants'
import { usePrintDocument } from '@/features/print/hooks/usePrintDocument'
import { OrderPrintEntry } from '@/features/print/types'
import MenuItem from '@/features/ui/buttons/components/MenuButton/parts/MenuItem'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'

interface OptionProps {
    entry: OrderPrintEntry
    isFirst?: boolean
}

const Option: FC<OptionProps> = ({ entry, isFirst = false }) => {
    const { t } = useTranslation()

    const { print, printing } = usePrintDocument()

    return (
        <MenuItem
            label={
                entry.printType === PrintJobType.Receipt && entry.receiptType
                    ? t(`receiptTypes.${entry.receiptType}`)
                    : t(`printJobTypes.${entry.printType}`, entry.printType)
            }
            onPress={() => void print(entry)}
            style={[styles.option, isFirst && styles.firstOption]}
            divider={false}
            disabled={printing}
        />
    )
}

const styles = StyleSheet.create({
    option: {
        borderColor: ColorEnum.GRAY_300,
        borderBottomWidth: 1,
        paddingHorizontal: 8,
    },
    firstOption: {
        borderTopWidth: 1,
    },
})

export default Option
